import * as React from 'react';

import { noop } from '@utils/noop';

import { IProductItemProps } from './model';
import { StyledProductTile } from './styled';
import { useProductItemProps } from './useGetProductItemProps';

export const ProductItem: React.FC<IProductItemProps> = React.memo(
  ({
    columns,
    description,
    order,
    noTags,
    buttonElementClassName,
    noPriceIfUnavailable,
    GTMEventLabel,
    onProductAdded = noop,
    onClosingCartModal = noop,
    trackAddToCartAsync,
    setProductWishlisted,
    sendGTM = false,
    useMasterUrl = false,
    showBuyButton = false,
    showWishlistButton = true,
    wishlisted = false,
    position = 0,
    inSectionOfType = '',
    appendComponent = null,
    product,
    innerRef,
    showAddToCartModal = true,
    canSpaRedirect = true,
    wishlistActionLocation,
  }) => {
    const productProps = useProductItemProps({
      noPriceIfUnavailable,
      useMasterUrl,
      inSectionOfType,
      GTMEventLabel,
      sendGTM,
      canSpaRedirect,
      setProductWishlisted,
      noTags,
      buttonElementClassName,
      onProductAdded,
      onClosingCartModal,
      trackAddToCartAsync,
      showBuyButton,
      showWishlistButton,
      showAddToCartModal,
      product,
      wishlisted,
      description,
      position,
      appendComponent,
      order,
      wishlistActionLocation,
    });

    if (!productProps) {
      return null;
    }

    return (
      <StyledProductTile
        data-testid="product-item"
        columns={columns}
        ref={innerRef}
        data-cypress="productItem-container"
        productProps={productProps}
      />
    );
  }
);

export default ProductItem;
